module.exports = __webpack_public_path__ + "static/media/picture12.8ece9a62.png";